import { api } from './client'
import type { Note } from '@/types'

export function fetchNotesByPriority(priorityId: string): Promise<Note[]> {
  return api.get(`/api/notes?priorityId=${priorityId}`)
}

export function fetchNotesByBucket(bucketId: string): Promise<Note[]> {
  return api.get(`/api/notes?bucketId=${bucketId}`)
}

export async function addNote(body: string, entity: { priorityId: string } | { bucketId: string }): Promise<string> {
  const { id } = await api.post<{ id: string }>('/api/notes', { body, ...entity })
  return id
}

export function deleteNote(id: string): Promise<void> {
  return api.delete(`/api/notes/${id}`)
}
